import { __extends } from "tslib";
import * as React from 'react';
import { Container } from '../../../primitives/container';
import { DeprecatedText } from '../../../deprecated-typography';
import { HeightAnimation } from '../../../animations';
var StepsContainerItem = /** @class */ (function (_super) {
    __extends(StepsContainerItem, _super);
    function StepsContainerItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepsContainerItem.prototype.render = function () {
        var props = this.props;
        var content = props.noBubble ? props.children :
            React.createElement(Container, { className: 'item-container' }, props.children);
        return (React.createElement("div", { className: 'steps-container-item' },
            React.createElement("div", { className: 'item-title' },
                React.createElement(DeprecatedText, { type: 't1' }, this.props.title)),
            React.createElement(HeightAnimation, { show: !!this.props.children }, content)));
    };
    return StepsContainerItem;
}(React.PureComponent));
export { StepsContainerItem };
//# sourceMappingURL=index.js.map